import PropTypes from 'prop-types';
import React from 'react';
import cuid from 'cuid';
import classNames from 'classnames';
import { getClassName, pageContext, get, replaceBaseUrl } from 'ctm-util-functions';
import styles from './picture.css';

const Picture = (props) => {
    const { elementProps = {}, visualProps } = props;
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    const { image, source } = elementProps;
    const variant = props.variant || visualProps.variant;
    // eslint-disable-next-line prefer-const
    let { alt, title } = image || props;
    let imageSrc;
    const className = classNames(props.className, variant && getClassName(styles, `variant_${variant}`));

    if (elementProps.source) {
        for (const srcConfig of elementProps.source) {
            if (srcConfig.srcSet) {
                srcConfig.srcSet = replaceBaseUrl(srcConfig.srcSet, baseAssetsPath);
            }
            if (get(srcConfig, 'image.src')) {
                srcConfig.image.src = replaceBaseUrl(srcConfig.image.src, baseAssetsPath);
            }
        }
    }

    if (props.src || elementProps.image.src) {
        imageSrc = replaceBaseUrl((props.src || elementProps.image.src), baseAssetsPath);
    }

    const imageComponent = <img alt={alt} src={imageSrc} title={title} className={className} />;
    if (source) {
        // We have various sources, so make them available via the <source> element.
        // NOTE: The sources do not change after load, so it's safe to use cuid().
        return (
            <picture>
                {source.map((sourceProps) => <source key={cuid()} {...sourceProps} />)}
                {imageComponent}
            </picture>
        );
    }
    return imageComponent;
};

Picture.propTypes = {
    elementProps: PropTypes.shape({
        image: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string.isRequired,
            title: PropTypes.string
        }),
        source: PropTypes.arrayOf(
            PropTypes.shape({
                srcSet: PropTypes.string.isRequired,
                type: PropTypes.string,
                media: PropTypes.string
            })
        )
    }),
    visualProps: PropTypes.shape({
        variant: PropTypes.string
    }),
    src: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    variant: PropTypes.string,
    className: PropTypes.string
};

Picture.defaultProps = {
    visualProps: {},
    elementProps: {}
};

export { Picture };
